export default "__VITE_ASSET__DOANqVBf__"